import { Component, ViewEncapsulation } from '@angular/core';
import { Observable, merge } from 'rxjs';
import { PendingApplicationsService } from './pending-applications.service';
import { UIBlockingService } from '../core/ui-blocking.service';
import { ToastNotificationService } from '../core/toast-notification.service';
import { DumbPendingApplication } from './DTOs/dumb-pending-application';
import { ActivatedRoute, Router } from '@angular/router';
import { PendingApplicationDetails } from './DTOs/pending-application-details';
import { NgbDropdown, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { EditCompanyInformationModalComponent } from './Modals/edit-company-information-modal.component';
import { EditLiaisonInformationModalComponent } from './Modals/edit-liaison-information-modal.component';
import { EditMembershipInformationModalComponent } from './Modals/edit-membership-information-modal.component';
import { VerifyRejectRequest } from '../core/verify-reject-request';
import { CommonLibrary } from '../core/common-library';

@Component({
    selector: 'app-pending-application-details',
    templateUrl: './pending-application-details.component.html',
    providers: [UIBlockingService, NgbDropdown],
    encapsulation: ViewEncapsulation.None,
})
export class PendingApplicationDetailsComponent {
    constructor(private pendingApplicationsService: PendingApplicationsService,
        private blockUI: UIBlockingService,
        private notificationService: ToastNotificationService,
        private route: ActivatedRoute,
        private router: Router,
        private modalService: NgbModal) {
    }

    protected readonly CommonLibrary = CommonLibrary;

    app: PendingApplicationDetails = new PendingApplicationDetails();
    appId: string;
    minorityCertsText: string;
    selfIdentitiesText: string;
    notes: string = "";
    salesForceId: string = "";
    salesForceSalesOppId: string = "";
    priceString: string = "";
    sfIdError: boolean = false;
    sfSalesOppIdError: boolean = false;

    ngOnInit() {
        this.appId = this.route.snapshot.paramMap.get("id");
        this.getPendingApplicationInfo();
    }

    getPendingApplicationInfo() {
        this.blockUI.start();
        this.pendingApplicationsService.getPendingApplicationInfo(this.appId).subscribe({
            next: (data) => {
                this.app = data;
                this.selfIdentitiesText = (data.selfIdentities.length > 0) ? data.selfIdentities.join(", ") : "None";
                this.minorityCertsText = (data.minorityCerts != null && data.minorityCerts.length > 0)
                    ? data.minorityCerts.map(x => x.text).join(", ") : "None";
                //this.priceString = data.price > 0 ? `$${data.price}` : CommonLibrary.getMembershipPriceForLevel(data.membershipLevel.value, data.employeeCount.value);
                this.priceString = data.price > 0 ? `$${data.price}` : "To be set";
            },
            error: (err) => {
                this.notificationService.error(err.error.message);
                console.log(err)
            },
            complete: () => {
                this.blockUI.stop();
            }
        });
    }
    editCompanyInfo(app: PendingApplicationDetails) {
        const modalRef = this.modalService.open(EditCompanyInformationModalComponent, { size: 'lg', backdrop: 'static' });
        modalRef.componentInstance.app = app;
        modalRef.result.then(response => {
            this.getPendingApplicationInfo();
        })
            .catch(err => {

            }).finally();
    }
    editLiaisonInfo(app: PendingApplicationDetails) {
        const modalRef = this.modalService.open(EditLiaisonInformationModalComponent, { size: 'lg', backdrop: 'static' });
        modalRef.componentInstance.app = app;
        modalRef.result.then(response => {
            this.getPendingApplicationInfo();
        })
            .catch(err => {

            }).finally();
    }
    editMembershipInfo(app: PendingApplicationDetails) {
        const modalRef = this.modalService.open(EditMembershipInformationModalComponent, { size: 'lg', backdrop: 'static' });
        modalRef.componentInstance.app = app;
        modalRef.result.then(response => {
            this.getPendingApplicationInfo();
        })
            .catch(err => {

            }).finally();
    }
    rejectApplication() {
        this.blockUI.start();
        var request = new VerifyRejectRequest(this.appId, this.notes, this.salesForceId, this.salesForceSalesOppId);
        this.pendingApplicationsService.rejectApplication(request).subscribe({
            next: (data) => {
            },
            error: (err) => {
                this.notificationService.error(err.error.message);
                this.blockUI.stop();
                console.log(err)
            },
            complete: () => {
                this.blockUI.stop();
                return this.router.navigate(['/admin-portal/chamber/pending-applications']);
            }
        });
    }
    approveApplication() {
        this.sfIdError = false;
        this.sfSalesOppIdError = false;

        if (this.salesForceId == "") {
            this.sfIdError = true;
        }
        if (this.salesForceSalesOppId == "") {
            this.sfSalesOppIdError = true;
        }
        if (this.sfSalesOppIdError || this.sfIdError) {
            return;
        }

        var total = parseFloat(this.priceString.replace('$', ''));
        if (Number.isNaN(total) || total <= 0) {
            this.notificationService.warning("Total cost must be set to a valid dollar amount");
            return;
        }
        this.blockUI.start();
        var request = new VerifyRejectRequest(this.appId, this.notes, this.salesForceId, this.salesForceSalesOppId);
        this.pendingApplicationsService.approveApplication(request).subscribe({
            next: (data) => {
            },
            error: (err) => {
                this.notificationService.error(err.error.message);
                this.blockUI.stop();
                console.log(err)
            },
            complete: () => {
                this.blockUI.stop();
                return this.router.navigate(['/admin-portal/chamber/pending-applications']);
            }
        });
    }

}
